import { DatePipe } from '@angular/common';
import { Component, inject, input, LOCALE_ID } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { IEnergyMeterList, Role } from '../../../../models/energy-meter';
import { Functions } from '../../../../services/shared/functions';
import { IconsStyles } from '../../../../services/shared/icons-styles';

@Component({
  selector: 'app-energy-meter-table',
  imports: [PanelModule, TableModule, DatePipe],
  templateUrl: './energy-meter-table.html',
  styleUrl: './energy-meter-table.css',
})
export class EnergyMeterTable {
  energyMeterList = input.required<IEnergyMeterList[]>();
  isLoading = input.required<boolean>();
  readonly locale = inject(LOCALE_ID);
  readonly iconsStyles = inject(IconsStyles);
  readonly roleEnum = Role;
  readonly customFunctions = inject(Functions);
  readonly shouldBeCollapsed = this.customFunctions.shouldBeCollapsed();
}
